import { EntityType } from '@frontend/common';
import { ErrorHandler } from '@frontend/error-handler';
import { ProductCategoryClient } from '@frontend/group/api';
import { GroupSelectV2 } from '@frontend/group/select';
import { NodeType } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import { useAccountRepository } from '@frontend/repository';
import { useState } from 'react';

import CreateModal from '../../../../modal/create-modal/create-modal.component';

export const CreateCategoryModal = () => {
    const { currentAccount } = useAccountRepository();
    const [parentCategory, setParentCategory] = useState<string | null>(null);
    return (
        <CreateModal
            required={['name']}
            order={['name']}
            formId='create-category-form'
            append={
                <div className='mt-2 w-full'>
                    <GroupSelectV2
                        type={EntityType.PRODUCT_CATEGORY}
                        queryParams={{ node_type: [NodeType.BRANCH, NodeType.ROOT] }}
                        label={CommonMessage.OBJECTS.CATEGORY.PARENT_CATEGORY}
                        value={parentCategory}
                        onChange={setParentCategory}
                    />
                </div>
            }
            type={EntityType.PRODUCT_CATEGORY}
            onSubmit={async (v) => {
                try {
                    const category = await ProductCategoryClient.postProductCategory(currentAccount, {
                        ...v,
                        node_type: parentCategory ? NodeType.BRANCH : NodeType.ROOT
                    });
                    if (parentCategory) {
                        await ProductCategoryClient.postProductCategoryMember(currentAccount, parentCategory, {
                            entity_id: category.id,
                            entity_type: EntityType.PRODUCT_CATEGORY
                        });
                    }
                    return category;
                } catch (error) {
                    ErrorHandler.handleError({ error: error as Error });
                    throw error;
                }
            }}
            submitDisabled={(v) => !v.name || !v.name_nl_be || !v.name_en_us || !v.name_fr_fr || !v.name_de_de}
            subForms={
                new Map([
                    [
                        CommonMessage.DETAIL.TRANSLATIONS,
                        {
                            order: ['name_nl_be', 'name_en_us', 'name_fr_fr', 'name_de_de'],
                            required: ['name_nl_be', 'name_en_us', 'name_fr_fr', 'name_de_de'],
                            collapsible: true,
                            defaultCollapsed: true
                        }
                    ]
                ])
            }
        />
    );
};
